import React, { useEffect, useState } from 'react';
// import QRCode from 'react-qr-code';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';
import { doc, increment, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

interface EventQRCodeProps {
  eventId: string;
  organizationId: string;
  size?: number;
  includeMargin?: boolean;
}

const EventQRCode: React.FC<EventQRCodeProps> = ({
  eventId,
  organizationId,
  size = 256,
  includeMargin = true
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [qrUrl, setQrUrl] = useState<string>('');

  useEffect(() => {
    const setupQRCode = async () => {
      try {
         // Create or get the QR code tracking document
         const qrTrackingRef = doc(db, 'qr_codes', `event_${eventId}`);
         const qrDoc = await getDoc(qrTrackingRef);

         if (!qrDoc.exists()) {
            // Initialize tracking document if it doesn't exist
            await setDoc(qrTrackingRef, {
               eventId,
               organizationId,
               totalScans: 0,
               created: new Date(),
               lastScan: null,
            });
         }

         // Generate the URL for the QR code with source parameter
         // This URL will redirect to the public event view and track QR scans separately
         const publicEventUrl = `${window.location.origin}/events/public/${eventId}?source=qr_scan`;
         setQrUrl(publicEventUrl);
         setLoading(false);
      } catch (err) {
        console.error('Error setting up QR code:', err);
        setError('Failed to generate QR code');
        setLoading(false);
      }
    };

    setupQRCode();
  }, [eventId, organizationId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
     <Paper
        elevation={2}
        sx={{
           p: 2,
           display: 'inline-block',
           bgcolor: 'white',
        }}
     >
        {/* <QRCode
        value={qrUrl}
        size={size}
        level="H"
        fgColor="#000000"
        bgColor="#ffffff"
      /> */}
     </Paper>
  );
};

export default EventQRCode; 